import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { ComboApi, FilterComboOptions } from 'api';

export const findCombo = createAsyncThunk(
  'combo/findCombo',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await ComboApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const filterCombo = createAsyncThunk(
  'combo/filterCombo',
  async (option: FilterComboOptions, { rejectWithValue }) => {
    try {
      const response = await ComboApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createCombo = createAsyncThunk(
  'combo/createCombo',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await ComboApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneCombo = createAsyncThunk(
  'combo/findOneCombo',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, option } = params;
      const response = await ComboApi.findOne(id, option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateCombo = createAsyncThunk(
  'combo/update',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await ComboApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeCombo = createAsyncThunk(
  'combo/removeCombo',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await ComboApi.remove(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  tableList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  savedPagination: any;
  savedList: Array<any>;
}

const initialState: IState = {
  tableList: [],
  list: [],
  reloadFlag: false,
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
  savedList: [],
};

const comboSlice = createSlice({
  name: 'combo',
  initialState,
  reducers: {
    reloadCombo(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    updateSavedPaginationCombo(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListCombo(state, action) {
      state.savedList = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(findCombo.fulfilled, (state, action) => {
      const { data } = action.payload;

      const newData = data.map(item => {
        return {
          ...item,
          key: item.id,
          value: item.id,
        };
      });

      state.list = newData;
    });
  },
});

const { actions, reducer: comboReducer } = comboSlice;

export const { reloadCombo, updateSavedPaginationCombo, updateSavedListCombo } =
  actions;

export default comboReducer;
